import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelTaboolaIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          d="M4.29888 2.18238C3.16201 2.17531 3.00364 3.28116 2.99874 4.11381C2.99384 4.94646 3.13915 6.07027 4.27548 6.0768C5.4118 6.08333 5.57072 4.96333 5.57561 4.12905C5.58051 3.29476 5.4352 2.18837 4.29888 2.18238ZM4.26459 8.25857C1.30895 8.2417 -0.0135016 6.27871 0.000103872 4.0964C0.0137093 1.91408 1.35684 -0.0173466 4.31248 0.000612538C7.26813 0.0185717 8.59003 1.96415 8.57697 4.14646C8.56391 6.32878 7.21861 8.27599 4.26459 8.25857Z"
          fill="#F7F9FD"
        />
        <path
          d="M11.7447 2.18189C10.6084 2.17536 10.4506 3.28067 10.4457 4.11441C10.4408 4.94815 10.5855 6.06978 11.7224 6.07686C12.8593 6.08393 13.0166 4.96285 13.0215 4.1291C13.0264 3.29536 12.8811 2.18788 11.7447 2.18189ZM11.7094 8.25917C8.7548 8.24121 7.43235 6.27822 7.44541 4.09645C7.45847 1.91468 8.80269 -0.017835 11.7573 0.000124187C14.7118 0.0180834 16.0348 1.96475 16.0223 4.14652C16.0098 6.32829 14.6645 8.2755 11.7094 8.25917Z"
          fill="#F7F9FD"
        />
        <path
          d="M1.12288 8.25928C3.25295 9.21111 5.46411 9.63397 7.87118 9.64757C10.4012 9.66227 12.3202 9.18444 14.7495 8.25928L14.7354 10.8808C12.5585 11.9589 10.2037 12.5406 7.85377 12.527C5.29594 12.5118 3.4456 11.9861 1.10547 10.8808L1.12288 8.25928Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
